import { axiosRubyClient } from '@/util/axios/axiosClient';

export type AppBinaryVersionPlatform = 'IOS' | 'ANDROID';

export type AppBinaryVersionPin = {
  id: number;
  platform: AppBinaryVersionPlatform;
  supported_versions: string[];
  gate_enabled: boolean;
  notes: string | null;
  last_synced_at: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type AppBinaryVersionPinPayload = {
  platform: AppBinaryVersionPlatform;
  supported_versions?: string[];
  gate_enabled?: boolean;
  notes?: string | null;
};

export type AppBinaryVersionPinUpdatePayload =
  Partial<AppBinaryVersionPinPayload>;

type ListResponse = { success: true; data: AppBinaryVersionPin[] };
type ShowResponse = { success: true; data: AppBinaryVersionPin };
type DeleteResponse = { success: true };

export const fetchAppBinaryVersionPins = async (): Promise<ListResponse> => {
  const response = await axiosRubyClient.get(
    '/api/admin/app_binary_version_pins',
  );
  return response.data;
};

export const createAppBinaryVersionPin = async (
  data: AppBinaryVersionPinPayload,
): Promise<ShowResponse> => {
  const response = await axiosRubyClient.post(
    '/api/admin/app_binary_version_pins',
    {
      app_binary_version_pin: data,
    },
  );
  return response.data;
};

export const updateAppBinaryVersionPin = async (
  id: number,
  data: AppBinaryVersionPinUpdatePayload,
): Promise<ShowResponse> => {
  const response = await axiosRubyClient.patch(
    `/api/admin/app_binary_version_pins/${id}`,
    { app_binary_version_pin: data },
  );
  return response.data;
};

export const deleteAppBinaryVersionPin = async (
  id: number,
): Promise<DeleteResponse> => {
  const response = await axiosRubyClient.delete(
    `/api/admin/app_binary_version_pins/${id}`,
  );
  return response.data;
};
